import { Component, OnInit, OnDestroy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Subscription } from 'rxjs';
import { NotificationService } from '../../services/notification.service';
import { NotificationData, NotificationComponent } from './notification.component';

@Component({
  selector: 'app-notification-display',
  standalone: true,
  imports: [CommonModule, NotificationComponent],
  template: `
    <div class="notification-display">
      <app-notification
        *ngFor="let notification of notifications"
        [notification]="notification"
        (close)="onCloseNotification($event)">
      </app-notification>
    </div>
  `,
  styles: [`
    .notification-display {
      position: fixed;
      top: 1rem;
      right: 1rem;
      z-index: 9999;
      display: flex;
      flex-direction: column;
      gap: 0.5rem;
      max-width: 400px;
      pointer-events: none;
    }
    
    app-notification {
      pointer-events: auto;
    }
    
    @media (max-width: 480px) {
      .notification-display {
        top: 0.5rem;
        right: 0.5rem;
        left: 0.5rem;
        max-width: none;
      }
    }
  `]
})
export class NotificationDisplayComponent implements OnInit, OnDestroy {
  notifications: NotificationData[] = [];
  private subscription?: Subscription;

  constructor(private notificationService: NotificationService) {}

  ngOnInit(): void {
    this.subscription = this.notificationService.notifications$.subscribe(
      notifications => this.notifications = notifications
    );
  }

  ngOnDestroy(): void {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
  }

  onCloseNotification(notificationId: string): void {
    this.notificationService.close(notificationId);
  }
}
